/**
 * Created by jv on 26/01/2017.
 */
//js
const Shared = require("Sources/shared");
const StoreShared = require("Sources/store-shared");
const LanguageManager = require("Sources/services/languagemanager");
const utils = require("Sources/utils/utils");
const StoreServices = require("Sources/services/fundels/store-services");
// const CatalogTemplate = require("Sources/templates/store-catalog.template");
const CatalogGridTemplate = require("Sources/templates/store-catalog-grid.template");
const CatalogGridLibraryTemplate = require("Sources/templates/store-catalog-grid-library.template");
const CatalogAddDialog = require("Sources/templates/store-catalog-add-dialog.template");
const Alerter = require("Sources/components/alerter");
const Tooltip = require("Sources/components/tooltip");

//Styles
require("Styles/pages/store/catalog-overview.scss");

$(function()
{
  LanguageManager.init(function()
  {
    StoreShared.init();
    catalogOverview.init();
  }, Shared.defaultLocale);
});

var catalogOverview = {};

(function(CatalogOverview)
{
  var catalog;
  var catalogTemplate;
  var catalogAddTemplate;

  var catalogScrollPos;

  CatalogOverview.init = function()
  {
    var userTypeAlert = new Alerter({
      insertAfter: $("body .page-wrapper > .header"),
      level: "info",
      type: "banner",
      text: utils.format(LanguageManager.getValueForKey("store.catalog.current_user_type.alert.message"), LanguageManager.getValueForKey(getReadableUserTypeForAlert(StoreShared.getUserType())), LanguageManager.getValueForKey(getReadableLocaleForAlert(StoreShared.getUserLocale()))),
      dismissible: true,
      fullWidth: true
    });

    setUpTitleForUserType();

    getCatalog(function()
    {
      if(!utils.isNullOrEmpty(catalog.extraInfoKey))
      {
        $("#catalog-info-text").show().html(LanguageManager.getValueForKey(catalog.extraInfoKey));
      }

      catalogAddTemplate = new CatalogAddDialog({
        title: LanguageManager.getValueForKey("store.catalog.add_dialog.title"),
        catalog: catalog,
        confirmBtnText: LanguageManager.getValueForKey("store.catalog.add_dialog.confirm.btn"),
        cancelBtnText: LanguageManager.getValueForKey("store.catalog.add_dialog.cancel.btn"),
        onConfirm: goToShoppingCart,
        onCancel: continueShopping
      });

      setUpOverview();
    });
  };

  function setUpTitleForUserType()
  {
    var userType = StoreShared.getUserType();
    var titleOptions = getTitleOptionsForUserType(userType);
    titleOptions.tooltip = null;
    var catalogTitleEl = $("#catalog-page-title");

    if(StoreShared.getUserType() === "BIB")
      catalogTitleEl.hide();
    else
      catalogTitleEl.text(titleOptions.title);

    if(utils.isNotNull(titleOptions.tooltip))
    {
      var tooltipEl = $("<button class='btn btn-icon frameless question-circle title-tooltip' type='button'></button>");

      Tooltip.create({
        selector: tooltipEl,
        content: titleOptions.tooltip
      });

      catalogTitleEl.after(tooltipEl);
    }

    if(titleOptions.showSearch)
    {
      var catalogSearchWrapper = $("#catalog-search-wrapper");

      catalogSearchWrapper.show();

      catalogSearchWrapper.find("input[type='text']").on("keyup", function(e)
      {
        if(e.keyCode === 13)
        {
          var $this = $(this);
          var inputVal = $this.val();

          if($this.hasClass("clearable") && !$this.hasClass("clear-active")  && !utils.isNullOrEmpty(inputVal))
          {
            $this.addClass("clear-active");
          }
          else if($this.hasClass("clearable") && $this.hasClass("clear-active") && utils.isNullOrEmpty(inputVal))
          {
            $this.removeClass("clear-active");
          }

          searchCatalog(inputVal);
        }
      });

      catalogSearchWrapper.find(".btn.btn-icon").on("click", function(e)
      {
        var inputEl = catalogSearchWrapper.find("input[type='text']");
        var inputVal = inputEl.val();

        if(inputEl.hasClass("clearable") && !inputEl.hasClass("clear-active") && !utils.isNullOrEmpty(inputVal))
        {
          inputEl.addClass("clear-active");
        }
        else if(inputEl.hasClass("clearable") && inputEl.hasClass("clear-active") && utils.isNullOrEmpty(inputVal))
        {
          inputEl.removeClass("clear-active");
        }

        searchCatalog(inputVal);
      });

      catalogSearchWrapper.find(".reset-btn").on("click", function(e)
      {
        var $this = $(this);

        $this.parent().find("input.clearable[type='text']").removeClass("clear-active").val("");
        searchCatalog();
      });
    }

    if(titleOptions.showSort)
    {
      var catalogSortWrapper = $("#catalog-sort-wrapper");
      var catalogSortSelect = $("#catalog-sort");

      catalogSortWrapper.show();

      catalogSortSelect.on("change", function(e)
      {
        sortCatalog($(this).val());
      });
    }
  }

  function getTitleOptionsForUserType(userType)
  {
    switch(userType)
    {
      case "SCH":
        return { title: LanguageManager.getValueForKey("store.catalog.school.title"), tooltip: LanguageManager.getValueForKey("store.catalog.school.tooltip"), showSearch: false, showSort: false };
      case "CON":
        return { title: LanguageManager.getValueForKey("store.catalog.consumer.title"), tooltip: LanguageManager.getValueForKey("store.catalog.consumer.tooltip"), showSearch: true, showSort: true };
      case "LIB":
        return { title: LanguageManager.getValueForKey("store.catalog.library.title"), tooltip: LanguageManager.getValueForKey("store.catalog.library.tooltip"), showSearch: true, showSort: true };
      case "LOG":
        return { title: LanguageManager.getValueForKey("store.catalog.logopaedics.title"), tooltip: LanguageManager.getValueForKey("store.catalog.logopaedics.tooltip"), showSearch: false, showSort: false };
      case "AND":
        return { title: LanguageManager.getValueForKey("store.catalog.other.title"), tooltip: LanguageManager.getValueForKey("store.catalog.other.tooltip"), showSearch: false, showSort: false };
      default:
        return { title: LanguageManager.getValueForKey("store.catalog.title"), tooltip: null, showSearch: false, showSort: false };
    }
  }

  function sortCatalog(sortProperty)
  {
    utils.devLog("Sorting catalog on property [%s]", sortProperty);

    if(utils.isNotNull(catalogTemplate))
    {
      if(utils.isNullOrEmpty(sortProperty))
      {
        catalogTemplate.reset();
      }
      else
      {
        catalogTemplate.sort({
          sortKey: sortProperty,
          sortType: "string"
        });
      }
    }
  }

  function searchCatalog(keyword)
  {
    utils.devLog("Filtering catalog on keyword [%s]", keyword);

    if(utils.isNotNull(catalogTemplate))
    {
      var emptyCatalogTextEl = $("#empty-catalog-text").hide();

      if(utils.isNullOrEmpty(keyword))
      {
        catalogTemplate.reset();
      }
      else
      {
        catalogTemplate.filter({
          property: null,
          filterValues: [ keyword ],
          exact: false
        });

        if(catalogTemplate.visibleArticles === 0)
        {
          emptyCatalogTextEl.show();
        }
      }
    }
  }

  function setUpOverview()
  {
    if(StoreShared.getUserType() !== "BIB")
    {
      catalogTemplate = new CatalogGridTemplate({
        appendTo: $("#catalog"),
        catalog: catalog,
        cart: StoreShared.sessionData.cart,
        addToCart: addArticleToCart,
        onShowDetails: showArticleDetails
      });

      if (StoreShared.getUserType() === "SCH")
      {
        $("#catalog").append("<p class='catalog-remark'>" + LanguageManager.getValueForKey("store.catalog.group_purchase.not_available") + "</p>")
      }
    }
    else
    {
      catalogTemplate = new CatalogGridLibraryTemplate({
        appendTo: $("#catalog"),
        catalog: catalog,
        cart: StoreShared.sessionData.cart,
        addToCart: addArticleToCart,
        onShowDetails: showArticleDetails
      });
    }
  }

  function showArticleDetails(article)
  {
    utils.devLog("Showing article details: %o", article);

    var articleDetailsEl = $("#catalog-article-details").empty();

    var articleDetailsWrapper = $("<div class='article-details'></div>");

    var articleTitleEl = $("<div class='article-title-wrapper'></div>");
    var backToCatalogBtn = $("<button class='btn btn-link title-back' type='button'>" + LanguageManager.getValueForKey("store.catalog.article_details.back") + "</button>").on("click", function(e)
    {
      showCatalog();
    });
    articleTitleEl.append(backToCatalogBtn).append("<h3 class='page-title'>" + article.title + "</h3>");

    var rightColumn = $("<div class='article-details-right'></div>");

    rightColumn.append(getArticleInfoEl(article));

    var leftColumn = $("<div class='article-details-left'></div>");
    //Article image
    leftColumn.append("<div class='article-details-image'><img src='" + article.image + "'></div>");
    //Article price
    leftColumn.append("<div class='article-details-price'><span class='price'>" + catalog.currency + " " + article.priceVat + "</span><span class='vat'>" + LanguageManager.getValueForKey("store.catalog.vat.inclusive") + " " + article.vatPercentage + "% " + LanguageManager.getValueForKey("store.catalog.vat") + "</span></div>");
    //Article add to cart
    var addToCartBtn = $("<button class='btn btn-main no-icon add-article-btn' type='button'>" + LanguageManager.getValueForKey("store.catalog.add_to_cart") + "</button>").attr("data-article-key", article.key);

    if(!article.purchasable && !utils.isNullOrEmpty(article.remark))
    {
      addToCartBtn.addClass("disabled");

      Tooltip.create({
        selector: addToCartBtn,
        content: article.remark,
        placement: "right"
      });
    }
    else if(article.alreadyOwned)
    {
      addToCartBtn.addClass("disabled");

      Tooltip.create({
        selector: addToCartBtn,
        content: LanguageManager.getValueForKey("store.catalog.article.already_owned"),
        placement: "right"
      });
    }
    else if(utils.isNotNull(StoreShared.sessionData.cart) && StoreShared.sessionData.cart.containsArticle(article.key) && article.purchaseOnce)
    {
      addToCartBtn.addClass("disabled");

      Tooltip.create({
        selector: addToCartBtn,
        content: LanguageManager.getValueForKey("store.catalog.article.purchase_once"),
        placement: "right"
      });
    }
    else
    {
      addToCartBtn.on("click", function(e)
      {
        var $this = $(this);

        if($this.hasClass("disabled"))
        {
          return;
        }

        var articleKey = $this.attr("data-article-key");

        var article = catalog.getArticleForKey(articleKey);

        if(utils.isNotNull(article) && !article.alreadyOwned)
        {
          addArticleToCart(articleKey);
        }
      });
    }

    leftColumn.append(addToCartBtn);

    articleDetailsWrapper.append(articleTitleEl);
    articleDetailsWrapper.append(leftColumn);
    articleDetailsWrapper.append(rightColumn);

    articleDetailsEl.append(articleDetailsWrapper);

    catalogScrollPos = $(document).scrollTop();
    doJsPageTransition(articleDetailsEl);
  }

  function getArticleInfoEl(article)
  {
    var articleInfo = $("<div class='article-details-info'></div>");

    if(utils.isNotNull(article.infoKey))
    {
      var infoPartial = getInfoPartialFromKey(article.infoKey);
      articleInfo.html(infoPartial);
    }
    else
    {
      if(utils.isNotNull(article.readableType))
      {
        //Article type
        articleInfo.append("<h5 class='article-details-type'>" + LanguageManager.getValueForKey(article.readableType) + "</h5>");
      }

      if(utils.isNotNull(article.author))
      {
        //Article author
        articleInfo.append("<div class='article-details-author'>" + article.author + "</div>");
      }

      if(utils.isNotNull(article.publisher))
      {
        //Article publisher
        articleInfo.append("<div class='article-details-publisher'>" + article.publisher+ "</div>");
      }
/*
      if(utils.isNotNull(article.themes))
      {
        //Article themes
        articleInfo.append("<span class='article-themes'><span class='article-info-label'>" + LanguageManager.getValueForKey("store.catalog.article_details.labels.themes") + "</span><span class='article-info-value'>" + article.themes.join(", ") + "</span></div>");
      }
*/
      if(!utils.isNullOrEmpty(article.age))
      {
        //Article age
        articleInfo.append("<div class='article-age'>" + article.age + "</div>");
      }

      //Article description
      articleInfo.append("<div class='article-details-description'>" + article.description+ "</div>");
    }

    return articleInfo;
  }

  function getInfoPartialFromKey(key)
  {
    var req = require.context("Views/store/article-details", false, /^\.\/.*\.html$/);

    try
    {
      var infoPageRequire = "./" + key + ".html";

      if($.inArray(infoPageRequire, req.keys()) !== -1)
      {
        return req(infoPageRequire);
      }
    }
    catch(e)
    {
      console.error(e);
    }

    return null;
  }

  function showCatalog()
  {
    doJsPageTransition($("#catalog"), true, function()
    {
      if(utils.isNotNull(catalogScrollPos))
      {
        // $("body, html").animate({
        //   scrollTop: catalogScrollPos
        // }, 300);

        $("body, html").scrollTop(catalogScrollPos);
      }
    });

    // $("body, html").scrollTop(catalogScrollPos);

    // $("body, html").animate({
    //   scrollTop: catalogScrollPos
    // }, 300);
  }

  function doJsPageTransition(toPage, reverse, callback)
  {
    // $("body, html").animate({
    //   scrollTop: 0
    // }, 300);
    // $("body, html").scrollTop(0);

    var wrapperTopOffset = $(".tr-pages").offset().top;
    var currentPage = $(".tr-pages .tr-page-current");
    var currentPageAbove = currentPage.index() < toPage.index();

    currentPage.removeClass("tr-page-current");
    toPage.addClass("tr-page-current");
    if(utils.isFunction(callback))
    {
      callback();
    }
    return;

    // 110% instead 100% so it gives the illusion that the 2 elements aren't right next to eachother but with some margin between them
    var currentPageTopOffset = currentPageAbove ? currentPage.offset().top - wrapperTopOffset : toPage.height() * -1,
        currentPageLeftOffsetStart = reverse === true ? "0" : "0",
        currentPageLeftOffsetEnd = reverse === true ? "110%" : "-110%",
        toPageTopOffset = currentPageAbove ? currentPage.height() * -1 : 0,
        toPageLeftOffsetStart = reverse === true ? "-110%" : "110%",
        toPageLeftOffsetEnd = reverse === true ? "0" : "0";

    currentPage.css("transform", "translate(" + currentPageLeftOffsetStart + ", " + currentPageTopOffset + "px)");
    toPage.addClass("tr-page-current").css("transform", "translate(" + toPageLeftOffsetStart + ", " + toPageTopOffset + "px)");

    // Force layout recalc
    currentPage.css("width");
    toPage.css("width");

    currentPage.css({
      "transform": "translate(" + currentPageLeftOffsetEnd + ", " + (currentPageTopOffset) + "px)",
      "transition": "transform 600ms"
    });

    toPage.css({
      "transform": "translate(" + toPageLeftOffsetEnd + ", " + (toPageTopOffset) + "px)",
      "transition": "transform 600ms"
    });

    setTimeout(function()
    {
      currentPage.removeClass("tr-page-current");
      currentPage.css({
        "transform": "none",
        "transition": "none"
      });

      toPage.css({
        "transform": "none",
        "transition": "none"
      });

      if(utils.isFunction(callback))
      {
        callback();
      }
    }, 600);
  }

  function addArticleToCart(key)
  {
    var article = catalog.getArticleForKey(key);
    var cartItem = StoreShared.sessionData.cart.getItemForArticleKey(key);

    if(utils.isNotNull(cartItem) && article.purchaseOnce)
    {
      utils.devLog("Article is already in cart and can only be purchased once");
      return;
    }

    if(article.purchasable)
    {
      utils.devLog("Adding article with key [%s] to shopping cart", key);

      var quantity = utils.isNotNull(cartItem) ? cartItem.quantity + 1 : 1;

      changeArticleQuantity(key, quantity, function()
      {
        $("#shopping-cart-quantity").text(StoreShared.sessionData.cart.itemCount);
        catalogAddTemplate.cartQuantity = StoreShared.sessionData.cart.itemCount;
        catalogAddTemplate.cartPrice = StoreShared.sessionData.catalog.currency + " " + StoreShared.sessionData.cart.totalPriceVat;
        catalogAddTemplate.article = article;
        catalogAddTemplate.show();
      });
    }
    else
    {
      Shared.Dialog.showMessageDialog(data.readableErrorTitle, data.readableErrorMessage);
      utils.devLog("Article with key [%s] is not purchasable.\nRemark: %s", key, article.remark);
    }
  }

  function goToShoppingCart()
  {
    utils.redirect("/store/cart");
  }

  function continueShopping()
  {
    if(!$("#catalog").is(":visible"))
    {
      showCatalog();
    }
  }

  function getReadableUserTypeForAlert(userType, locale)
  {
    switch(userType)
    {
      case "BIB":
        return LanguageManager.getValueForKey("store.catalog.current_user_type.library");
      case "SCH":
        return LanguageManager.getValueForKey("store.catalog.current_user_type.school");
      case "CON":
        return LanguageManager.getValueForKey("store.catalog.current_user_type.consumer");
      case "LOG":
        return LanguageManager.getValueForKey("store.catalog.current_user_type.logopaedic");
      case "KND":
        return LanguageManager.getValueForKey("store.catalog.current_user_type.knd");
      case "PSZ":
        return LanguageManager.getValueForKey("store.catalog.current_user_type.psz");
      default:
        return userType;
    }
  }

  function getReadableLocaleForAlert(locale)
  {
    switch(locale.toUpperCase())
    {
      case "NL_BE":
        return LanguageManager.getValueForKey("store.catalog.current_user_locale.nl_BE");
      case "NL_NL":
        return LanguageManager.getValueForKey("store.catalog.current_user_locale.nl_NL");
      default:
        return locale;
    }
  }

  function getCatalog(callback)
  {
    StoreServices.getCatalog(null,
      function(data)
      {
        // Success
        catalog = data;

        utils.devLog("Catalog: %o", catalog);

        if(utils.isFunction(callback))
        {
          callback();
        }
      },
      function(data)
      {
        // Failed
        Shared.Dialog.showMessageDialog(data.readableErrorTitle, data.readableErrorMessage);
        console.error("Something went wrong trying to fetch catalog\ndata: %o", data);
      }
    );
  }

  function changeArticleQuantity(key, quantity, callback)
  {
    StoreServices.setCartArticleQuantity(key, quantity,
      function(data)
      {
        // Success
        utils.devLog("Shopping cart after article add: %o", data);

        StoreShared.sessionData = data;

        if(utils.isFunction(callback))
        {
          callback(data);
        }
      },
      function(data)
      {
        // Fail
        Shared.Dialog.showMessageDialog(data.readableErrorTitle, data.readableErrorMessage);
        console.error("Failed to add article with key [%s] to cart\ndata: %o", key, data);
      }
    );
  }

}(catalogOverview));



// WEBPACK FOOTER //
// ./app/js/entries/store/catalog-overview.js